export class Topic {
    constructor() {
        this.topicSelect = document.getElementById(Topic.topicSelectId);
    }
    addOnChange(onChange) {
        this.topicSelect.addEventListener("change", () => onChange(this.topicSelect));
        onChange(this.topicSelect);
    }
}
Topic.topicSelectId = "topic";
